<template>
  <el-container class="container">
    <transition name="slide-fade">
      <div v-show="isSwitch" class="aside-cont">
        <div class="logo">
          <div class="f-imgtopbox2">
            <transition>
              <p class="title"></p>
            </transition>
          </div>
        </div>
        <!--<div v-show="isSwitch" class="icon_switch" style="right:-15px;" @click="isSwitch=!isSwitch">
          <i :class="isSwitch?'el-icon-caret-left':'el-icon-caret-right'"></i>
        </div>-->
        <v-left-nav-bar></v-left-nav-bar>
      </div>
    </transition>
    <el-container>
      <el-header class="header flex-box">
        <div style="flex: 1" class="g-top-breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <ul class="header-right flex-box">
          <li>
            <i class="iconfont icon-denglu"></i>
            <el-dropdown trigger="click" >
                <span class="el-dropdown-link">
                  {{adminName || '管理员'}}<i class="el-icon-arrow-down el-icon--right" style="margin-top: -6px;"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <div>
                  <el-dropdown-item :command="1"><b @click="logOut">退出</b></el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </el-header>
      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>
    <transition name="slide-fade">
      <div v-if="!isSwitch" class="icon_switch" style="left:0;" @click="isSwitch=!isSwitch">
        <i :class=" isSwitch?'el-icon-caret-left':'el-icon-caret-right'"></i>
      </div>
    </transition>
  </el-container>
</template>
<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'
  import {clickUrl} from '../config/env'

  export default {
    data() {
      return {
        isCollapse: false,
        toggleSystem: false,
        isSwitch: true,
        applicationActive: 0,
        active: '',
        name: '',
        seacrhcont: '',
        path: '',
        adminName:'',
        adminPortraitUrl: '',
        headerNavList: [],
        asideList: [],
        nowSystem: 0,
        url: this.$route.path,
        query: this.$route.query.single,
        netaddress: '',
        myPermission: {},
        logoUrl: '',
        isActive: '',
        selectList: [],
        isSelectAll: false,
        isDataCenter: false,
        otherSystemUrl: ''
      }
    },
    created() {
    },
    mounted() {
      this.adminName = sessionStorage['adminName'];
    },
    methods: {
      judgeBuildingDetail(val, id) {
        if (val == '/index') {
          // this.$router.replace({path: '/applicationList'});
          this.applicationActive = 0;
        } else {
          this.asideList.forEach((item, index) => {
            if (val.indexOf(item.path) != -1) {
              this.applicationActive = index;
            }
          })
        }
      },
      logOut(){
        getData.logout().then(res => {
          if(res.data.code == 1){
            sessionStorage.clear()
            this.$router.replace('/login')
          }
        })
      }
    },
    watch: {
      '$route'(val) {
        this.judgeBuildingDetail(val.path);

      }
    }
  }
</script>
<style lang="scss">
  @import '../assets/css/mixin';

  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .container {
    width: 100%;
    height: 100%;
    background-color: #f8f8f9;
    /*min-width: 1300px;*/
    .header {
      height: 79px !important;
      padding: 0;
      // background-color: #3b3d43;
      background: url('../../static/img/head-img.png');
      justify-content: space-between;
      .g-top-breadcrumb{
        margin-left: 20px;
      }
      .header-right{
        margin-right: 50px;
        li:after{
          display: none;
        }
        .el-dropdown-link{
          font-size: 14px;
        }
        .icon-denglu{
          font-size: 24px;
          color: $fc;
        }
      }
      .collapse {
        padding: 0 16px;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        i {
          color: #2a92e7;
          font-size: 20px;
        }
        &:hover {
          background-color: rgba(42, 146, 231, .2);
        }
      }
      .g-searchinput {
        margin-left: 35px;
        width: 229px;
        height: 43px;
      }
      .crumb-box {
        flex: 1;
      }
      .user-box {
        margin-right: 30px;
        .btn {
          color: #657984;
          padding: 0 10px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          &:hover {
            background-color: rgba(42, 146, 231, .2);
          }
          i {
            font-size: 20px;
          }
        }
      }
      .navbar li.el-menu-item:hover {
        background-color: rgb(80, 86, 107);
      }
    }
    .aside-cont {
      position: relative;
      // background-color: #3b3d43;
      width: 230px;
      background: url('../../static/img/left-img.png');
      background-size: contain;
      .logo {
        position: relative;
        height: 79px;
        /*background-color: #f8f8f9;*/
        overflow: hidden;
        position: relative;
        text-align: center;
        padding: 0 10px;
        .f-imgtopbox {
          position: absolute;
          top: 20px;
          left: 50%;
          margin-left: -24px;
          @include wh(45px, 49px);
        }
        .f-imgtopbox2 {
          position: absolute;
          top: 20px;
          left: 50%;
          margin-left: -80px;
          @include wh(160px, 49px);
          .title{
            // color: #fff;
            // text-align: center;
            // margin-top: 10px;
            // font-size: 25px;
            height: 36px;
            background: url('../../static/img/logo.png') no-repeat;
            background-size: contain;
          }
        }
      }
      > .el-menu {
        height: calc(100% - 90px);
        height: -moz-calc(100% - 90px);
        height: -webkit-calc(100% - 90px);
        border-right: none;
        background-color: transparent;
        text-align: left;
        &:not(.el-menu--collapse) {
          width: 230px !important;
          overflow: auto
        }
      }
      .g-userinfo {
        position: relative;
        height: 90px;
        border-bottom: 2px solid #333743;
        .imgsboxs {
          position: relative;
          width: 52px;
          height: 52px;
          border: 1px solid #007de3;
          border-radius: 50%;
          margin-right: 20px;
          img {
            width: 52px;
            height: 52px;
            object-fit: cover;
            border-radius: 50%;
          }
          &:after {
            position: absolute;
            content: '';
            right: 0;
            bottom: 6px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #007de3;
            border: 1px solid #FFFFFF;
          }
        }
        .smallimgsboxs {
          position: absolute;
          margin: 0;
          top: 18px;
          left: 50%;
          margin-left: -26px;
        }
      }
    }
    .main {
      /*margin: 15px;*/
      padding: 35px;
      /*padding-top: 5px;*/
      position: relative;
      border-radius: 3px;
      background: #EDF2F8;
      /*border-top: 3px solid #d2d6de;*/
      /*margin-bottom: 20px;*/
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      flex: 1;
      .main-box {
        overflow: auto;
        /*padding: 15px;*/
        min-width: 930px;
        padding-bottom: 20px;
        flex: 1;
      }
    }
    .main1 {
      position: relative;
      flex: 1;
      .main-box {
        overflow: auto;
        min-width: 1030px;
        flex: 1;
      }
    }
  }

  .img {
    width: 55px;
    height: 35px;
    margin-right: 10px;
  }

  .content-right {
    flex: 1;
  }

  .index-side-list {
    padding: 20px 10px;
    padding-left: 0;
    max-height: 100%;
    box-sizing: border-box;
    overflow: auto;
    li {
      display: flex;
      padding: 10px;
      width: 161px;
      border-left: 3px solid #333743;
      margin-top: 4px;
      h3 {
        color: #fff;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
      p {
        color: rgba(51, 204, 255, 0.768627450980392);
        font-size: 10px;
      }
      i {
        font-size: 14px;
      }
    }
    .active {
      background: #14161b;
      border-left: 3px solid #0CB1F8;
      color: #fff;
      p {
        i, span {
          color: #fff;
        }
      }
    }
    .active2 {
      background: #0BABF7;
      border: 1px solid #0BABF7;
      p {
        color: #fff;
      }
    }
  }

  .side-btn {
    background: #333743;
    color: #0BABF7;
    border: 1px solid rgba(11, 171, 247, 1);
    width: 100%;
  }

  .side-btn:hover, .side-btn:focus {
    background: #333743;
    color: #0BABF7;
    border: 1px solid rgba(11, 171, 247, 1);
  }

  .header-nav {
    /*width: 60%;*/
    margin-left: 20px;
    li {
      /*flex: 1;*/
      text-align: center;
      border-bottom: 4px solid #50566B;
      color: #fff;
      margin-left: 20px;
      padding: 18px 20px;
      cursor: pointer;
      p {
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
      }
    }
    li:hover {
      border-bottom: 4px solid #0BABF7;
      color: #0BABF7;
    }
    .active {
      border-bottom: 4px solid #0BABF7;
      color: #0BABF7;
    }
  }

  .system-name {
    padding-left: 20px;
    text-align: left;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
  {
    transform: translateX(-200px);
    opacity: 0;
  }

  .g-elmenu {
    width: 160px;
  }

  .dialog__checkSystem {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    z-index: 1000;
  }

  .toggle_system {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #3c4152;
    height: 126px;
    ul {
      display: flex;
      align-items: center;
      padding: 12px;
      li {
        width: 108px;
        height: 100px;
        border: 1px solid #3c4152;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        margin-left: 20px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        p {
          line-height: 24px;
          font-size: 12px;
          margin-top: -15px;
        }
      }
      .active {
        border: 1px solid #0FC5FC;
      }
    }
  }

  .system_icon {
    width: 88px;
    height: 88px;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue